import { apiAction } from 'actions/application'
import { getPlatformLogicalSlots } from 'services/logicalSlots'
import {
  getParameterGroups,
  getParameterAddresses,
  getCompatibilityModules,
} from 'services/apiLookUpValues'
import { logicalSlotResponseSchema } from 'schemas/logicalSlots'
import { compatibilityModulesResponseSchema } from 'schemas/referenceParameter'
import { getPlatformFromRP } from 'utils/referenceParameter'
import { supportingDataErrorHandler } from 'sagas/errorHandlers'

export const GET_LOGICAL_SLOTS = 'GET_LOGICAL_SLOTS'
export const getLogicalSlots = (rp) => {
  const platform = getPlatformFromRP(rp)

  return apiAction({
    asyncFn: getPlatformLogicalSlots,
    successActionType: GET_LOGICAL_SLOTS,
    args: { platform },
    schema: logicalSlotResponseSchema,
  })
}

export const PARAMETER_GROUPS_RECEIVED = 'PARAMETER_GROUPS_RECEIVED'
export const PARAMETER_GROUPS_NOT_RECEIVED = 'PARAMETER_GROUPS_NOT_RECEIVED'
export const requestParameterGroups = () =>
  apiAction({
    asyncFn: getParameterGroups,
    successActionType: PARAMETER_GROUPS_RECEIVED,
    failureActionType: PARAMETER_GROUPS_NOT_RECEIVED,
    errorHandlers: [supportingDataErrorHandler],
  })

export const PARAMETER_ADDRESSES_RECEIVED = 'PARAMETER_ADDRESSES_RECEIVED'
export const PARAMETER_ADDRESSES_NOT_RECEIVED =
  'PARAMETER_ADDRESSES_NOT_RECEIVED'
export const requestParameterAddresses = () =>
  apiAction({
    asyncFn: getParameterAddresses,
    successActionType: PARAMETER_ADDRESSES_RECEIVED,
    failureActionType: PARAMETER_ADDRESSES_NOT_RECEIVED,
    errorHandlers: [supportingDataErrorHandler],
  })

export const REQUESTING_COMPATIBILITY_RULES = 'REQUESTING_COMPATIBILITY_RULES'
export const COMPATIBILITY_RULES_RECEIVED = 'COMPATIBILITY_RULES_RECEIVED'
export const COMPATIBILITY_RULES_NOT_RECEIVED =
  'COMPATIBILITY_RULES_NOT_RECEIVED'
export const requestCompatibilityModules = () =>
  apiAction({
    asyncFn: getCompatibilityModules,
    successActionType: COMPATIBILITY_RULES_RECEIVED,
    failureActionType: COMPATIBILITY_RULES_NOT_RECEIVED,
    schema: compatibilityModulesResponseSchema,
  })
